export default __webpack_public_path__ + "static/media/Arrow_right.d11a9b1c.svg";